import { useEffect, useState } from 'react';
import { apiService } from '../../services/api';
import type { Domain, Sector, Service } from '../../types/api';

type NavData = { domains: Domain[]; sectors: Sector[]; services: Service[]; loaded: boolean };
const empty: NavData = { domains: [], sectors: [], services: [], loaded: false };
let cache: NavData | null = null;
let pending: Promise<NavData> | null = null;

function load(): Promise<NavData> {
  pending ??= Promise.all([
    apiService.getDomains().catch(() => []),
    apiService.getSectors().catch(() => []),
    apiService.getServices().catch(() => []),
  ]).then(([domains, sectors, services]) => {
    cache = {
      domains: domains.filter((d) => d.enable),
      sectors: sectors.filter((s) => s.enable),
      services: services.filter((s) => s.enable),
      loaded: true,
    };
    return cache;
  });
  return pending;
}

/** Domaines, secteurs et services pour les menus et le footer (chargés une seule fois). */
export function useNavData(): NavData {
  const [data, setData] = useState<NavData>(cache ?? empty);
  useEffect(() => {
    let alive = true;
    load().then((d) => alive && setData(d));
    return () => { alive = false; };
  }, []);
  return data;
}
